import * as companyService from 'resources/company/company.service';
import * as storageService from 'services/storage.service';

const removeCompanyLogo = async ({ companyId, logoUrl }) => {
  if (logoUrl) {
    const bucketPath = 'companies/';
    const path = logoUrl.substr(logoUrl.indexOf(bucketPath) + bucketPath.length);

    await storageService.removeFile({
      bucket: 'companies',
      path,
    });

    await companyService.updateCompany({
      id: companyId,
      logo_url: null,
    });
  }
};

export default removeCompanyLogo;
